// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"36e638f0","281":"0a66c39f","329":"81cbfe20","331":"f461f8b7","355":"7f988479","420":"5738d85c","523":"07e3dc09","590":"587824f5","603":"974f18f7","667":"d9df5cea","678":"64ac4f3e","736":"5c81a769","856":"c6b1810a","872":"bd2f6d5b","915":"8d76655a"}[chunkId] + ".chunk.js";
};